import { Injectable } from '@angular/core';
import { EnvironmentService } from '../../core/services/environment.service';
import { EMPTY, Observable } from 'rxjs';
import { VCPM } from 'pcs-domain';
import { VCPMService } from '../../core/services/vcpm.service';
import { DashboardState } from '../../store/dashboard/dashboard.state';
import { Store } from '@ngxs/store';
import { FormBuilder, Validators } from '@angular/forms';
import { emailsValidator } from '../../core/services/email.validator';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { Internal } from '../../core/decorators/app.decorators';

@Internal()
@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  config: any;
  products: VCPM.ProductOffering[] | undefined = undefined;
  constructor(private store: Store, private envService: EnvironmentService, private fb: FormBuilder, public http: HttpClient) {
    this.config = this.envService.config;
   }
   
  getProductOfferings(): Observable<VCPM.ProductOffering[]> {
    if(this.products){return of(this.products)};// Cached response
    return this.http.get<VCPM.ProductOffering[]>(`${this.config.dataProviderAPIUrl}products`);
  }

  getCopyName(projectId: string | number, isAdmin: boolean = false) {
    let projectList: any = [];
    if(isAdmin){
      projectList = this.store.selectSnapshot(DashboardState.getAllUsersProjects);
    }
    else{
      projectList = this.store.selectSnapshot(DashboardState.getUserProjects);
    }
    let sourceName = projectList.find((x: any) => x.projectId == projectId)?.metadata.projectName;
    let cloneNameWithSuffix = ''
    sourceName = sourceName && /-copy(\d+){0,1}$/.test(sourceName.trim()) ? sourceName.substring(0, sourceName.indexOf('-copy')) : sourceName;
    const cloneName = sourceName + '-copy';
    const projectNameList = projectList.map((x: any) => x.metadata.projectName?.toLowerCase());
    projectNameList.push(sourceName.toLowerCase() + '-copy');
    let suffix: number = 1;
    cloneNameWithSuffix = cloneName;
    while (projectNameList.includes(cloneNameWithSuffix.toLowerCase())) {
      suffix = ++suffix;
      cloneNameWithSuffix = `${cloneName}${suffix}`;
    }
    return cloneNameWithSuffix;
  }

  initializeSharingForm() {
    let shareProjectForm = this.fb.group({
      toUser: this.fb.control([], [Validators.required, emailsValidator]),
      shareType: this.fb.control('shareCopy', Validators.required)
    });
    return {shareProjectForm};
  }

  getCustomerList(searchTerm: string | null) {
    const payload = {
        "searchBy": "ANY",
        "searchKey": searchTerm
    }
    if (searchTerm !== null && searchTerm !== '') {
        return this.http.post<any>(`${this.envService.config.sfdcUrl}/v1/customers/search?source=oracle`, payload);
    } else {
        return EMPTY;
    }

}
}
